@use "../../variables" as *;
@use "../../mixins" as *;

.tag {
  padding: 0.25rem 0.625rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $grey-text;
  font-size: 0.75rem;
  line-height: 0.75rem;
  letter-spacing: 0.1rem;
  color: $white;

  &.red {
    background-color: $ny-red;
    padding: .75rem;
    font-size: min(3.5vw, 1.2rem);
    letter-spacing: 1.6px;
    color: $white;
    min-width: min(17vw, 5.313rem);

    @include tablet {
      padding: 1rem;
      font-size: min(2vw, 1.2rem);
      min-width: min(6vw, 4.688rem);
    }
  }

  &.highlightTag {
    font-size: min(2vw, .6rem);
  }
}